import { topics } from "@/mocks/home";

export default function SectionTopics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">大家都在关注的内容方向</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group flex items-center gap-2 px-4 py-2 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-200"
            >
              <span className={`w-2 h-2 rounded-full ${item.color}`}></span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</span>
              {item.tag && (
                <span className="text-[11px] font-medium text-primary-500 bg-primary-50 px-1.5 py-0.5 rounded">
                  {item.tag}
                </span>
              )}
              <span className="text-xs text-foreground-500 ml-1">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}